export default __webpack_public_path__ + "static/media/unnamed.21d95a57.png";